import React from 'react';
import {  TableCell, TableRow, } from 'carbon-components-react';
import CompareField from './compare-field';
import { formatDate } from '../../components/formatters';

const DependentsTableRow = ({modified, unmodified}) => {

    return ( 
        <>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.firstName} unmodifiedValue={unmodified?.firstName} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.lastName} unmodifiedValue={unmodified?.lastName} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.ssn} unmodifiedValue={unmodified?.ssn} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={formatDate(modified?.birthdate)} unmodifiedValue={formatDate(unmodified?.birthdate)} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.gender?.name} unmodifiedValue={unmodified?.gender?.name} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.relationship?.name} unmodifiedValue={unmodified?.relationship?.name} />
            </TableCell>
        </>
     );
}
 
export default DependentsTableRow;